import { Link as ReactRouterLink } from 'react-router'
import styled from '@emotion/styled'
import { fontSecondary } from 'src/ui-kit/fonts/fontFamily'

export const Link = styled(ReactRouterLink)`
    ${fontSecondary}
    font-weight: 600;
    text-transform: uppercase;
`
